<template>
  <v-layout row wrap>
    <v-flex class="login-overlay pb-5">
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-flex class="login-inner" xs12 sm6 md4 xl3>
          <img
            :src="publicPath + 'img/logo-vote.png'"
            @click="logoClick"
            style="width: 100%; max-width: 300px; cursor: pointer"
          />
          <template v-if="state == 'login'">
            <v-flex xs12>
              <v-text-field
                :label="$t('fields.email')"
                @keyup.native.enter="loginClick"
                outline
                prepend-icon="fa-user"
                type="email"
                v-model="loginData.email"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :label="$t('fields.password')"
                @keyup.native.enter="loginClick"
                outline
                prepend-icon="fa-lock"
                type="password"
                v-model="loginData.password"
              ></v-text-field>
            </v-flex>
            <v-flex class xs12>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <span @click="registerClick" class="forgot-button">{{
                  $t('loginScreen.register')
                }}</span>
              </v-layout>
            </v-flex>
            <v-flex class="mb-3 pb-5" xs12>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <span @click="forgotPasswordToggle" class="forgot-button">{{
                  $t('loginScreen.forgotPassword')
                }}</span>
              </v-layout>
            </v-flex>
            <v-flex class="mt-5" xs12>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn @click="loginClick" color="primary">{{
                  $t('loginScreen.login')
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-layout>
            </v-flex>
          </template>
          <template v-if="state == 'reset'">
            <v-flex xs12>
              <v-text-field
                :label="$t('fields.email')"
                @keyup.native.enter="resetClick"
                outline
                prepend-icon="fa-envelope"
                type="text"
                v-model="resetData.email"
              ></v-text-field>
            </v-flex>
            <v-flex class="mt-5" xs12>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn @click="resetClick" color="primary">{{
                  $t('loginScreen.reset')
                }}</v-btn>
                <v-btn @click="forgotPasswordToggle" color="primary">{{
                  $t('loginScreen.back')
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-layout>
            </v-flex>
          </template>
          <template v-if="state == 'tfa'">
            <v-flex xs12>{{ $t('loginScreen.tfaDescription') }}</v-flex>
            <v-flex xs12 mt-5>
              <v-text-field
                @keyup.native.enter="checkTfa"
                :label="$t('fields.pin')"
                outline
                type="text"
                v-model="tfaData.pin"
              ></v-text-field>
            </v-flex>
            <v-flex class="mt-5" xs12>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn @click="checkTfa" color="primary">{{
                  $t('loginScreen.check')
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-layout>
            </v-flex>
          </template>
          <v-flex class="mt-2" xs12>
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <span
                @click="languageSwitchClick('en')"
                class="forgot-button"
                v-if="$i18n.locale == 'hr'"
                >{{ $t('loginScreen.switchToEnglish') }}</span
              >
              <span
                @click="languageSwitchClick('hr')"
                class="forgot-button"
                v-if="$i18n.locale == 'en'"
                >{{ $t('loginScreen.switchToCroatian') }}</span
              >
              <v-spacer></v-spacer>
            </v-layout>
          </v-flex>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'Login',
  data: function () {
    return {
      publicPath: process.env.BASE_URL,
      loginData: {
        email: '',
        password: '',
        remember: false,
        login_secret: null,
      },
      resetData: {
        email: '',
      },
      state: 'login',
      resetPassword: false,
      tfaData: {
        email: '',
        pin: '',
        login_secret: null,
      },
    }
  },
  methods: {
    switchDevicePrompt(callback) {
      // This prompt is always displayed on the default app language, not the user language,
      // because the user is not logged in at the moment when this prompt is displayed.
      this.$prompt(
        this.$t('components.login.switchDevicePrompt.title'),
        this.$t('components.login.switchDevicePrompt.message'),
        callback
      )
    },

    checkTfa() {
      this.$APICall(
        'post',
        'TFA',
        '-check',
        this.tfaData,
        data => {
          if (data.success) {
            this.$store.dispatch('setLoggedIn', true).then(() => {
              this.$i18n.locale = data.user.language
              this.$router.push({ name: 'Events' })
            })
          } else {
            if (!data.terms) {
              this.$verifyHtml(data.terms_text, response => {
                if (response) {
                  this.$APICall(
                    'post',
                    'ACCEPT_TERMS',
                    '',
                    this.loginData,
                    () => {
                      this.checkTfa()
                    },
                    true,
                    error => {
                      handle_session_error(
                        error,
                        this.$store,
                        this.$router,
                        this.$prompt
                      )
                    }
                  )
                }
              })
            } else {
              this.$alert(this.$t('ballot.pinFail'))
            }
          }
        },
        true,
        error => {
          if (error.response.status === 409) {
            this.switchDevicePrompt(result => {
              if (result === false) {
                return
              }

              this.tfaData.login_secret = error.response.data.data.login_secret

              this.checkTfa()
            })
          }
        }
      )
    },
    registerClick() {
      window.location = 'https://fair-votes.com/o-nama#kontakt'
    },
    resetAllData() {
      this.loginData.email = ''
      this.loginData.password = ''
      this.loginData.reset = false
      this.resetData.email = ''
    },
    forgotPasswordToggle() {
      if (this.state == 'login') {
        this.resetAllData()
        this.state = 'reset'
      } else {
        this.resetAllData()
        this.state = 'login'
      }
    },
    loginClick() {
      let vm = this
      var message = ''
      if (this.loginData.email == '') {
        message += this.$t('alerts.emailMissing') + '<br />'
      } else {
        if (this.$checkEmail(this.loginData.email) == false) {
          message += this.$t('alerts.emailVerification') + '<br />'
        }
      }
      if (this.loginData.password == '') {
        message += this.$t('alerts.passwordMissing') + '<br />'
      }
      if (message == '') {
        this.$APILogin(
          this.loginData,
          data => {
            if (!data.success) {
              if (data.message == 'Wrong credentials.') {
                vm.$alert(vm.$t('alerts.wrongCredentials'))
              }
              if (data.message == 'User is disabled.') {
                vm.$alert(vm.$t('alerts.userDisabled'))
              }
              if (data.message == 'Client is expired.') {
                vm.$alert(vm.$t('alerts.clientExpired'));
              }
              if (!data.terms) {
                vm.$verifyHtml(data.terms_text, response => {
                  if (response) {
                    vm.$APICall(
                      'post',
                      'ACCEPT_TERMS',
                      '',
                      vm.loginData,
                      function () {
                        vm.loginClick()
                      },
                      true,
                      error => {
                        handle_session_error(
                          error,
                          this.$store,
                          this.$router,
                          this.$prompt
                        )
                      }
                    )
                  }
                })
              }
            } else {
              if (data.tfa_popup) {
                vm.$alert(vm.$t('alerts.tfaPopup'))
              }
              if (data.tfa) {
                vm.tfaData.email = this.loginData.email
                vm.$APICall(
                  'post',
                  'TFA',
                  '-send',
                  vm.tfaData,
                  function (data) {
                    if (data.success) {
                      vm.state = 'tfa'
                    }
                  },
                  true,
                  null
                )
              } else {
                this.$store.dispatch('setLoggedIn', true).then(() => {
                  this.$i18n.locale = data.user.language
                  this.$router.push({ name: 'Events' })
                })
              }
            }
          },
          error => {
            if (error.response.status === 409) {
              this.switchDevicePrompt(result => {
                if (result === false) {
                  return
                }

                this.loginData.login_secret =
                  error.response.data.data.login_secret

                this.loginClick()
              })
            }
          }
        )
      } else {
        this.$alert(message)
      }
    },
    resetClick() {
      var message = ''
      if (this.resetData.email == '') {
        message += this.$t('alerts.emailMissing') + '<br />'
      } else {
        if (this.$checkEmail(this.resetData.email) == false) {
          message += this.$t('alerts.emailVerification') + '<br />'
        }
      }
      if (message == '') {
        let vm = this
        this.$APICall(
          'post',
          'PASSWORD_RESET',
          '/' + this.$i18n.locale,
          this.resetData,
          function (data) {
            if (data.success) {
              vm.$alert(vm.$t('alerts.passwordResetSuccess'))
              vm.forgotPasswordToggle()
            } else {
              if (data.message == 'wrong email') {
                vm.$alert(vm.$t('alerts.passwordResetFail'))
              }
              if (data.message == 'account disabled') {
                vm.$alert(vm.$t('alerts.userDisabled'))
              }
            }
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(message)
      }
    },
    logoClick() {
      window.open('https://fair-votes.com')
    },
    languageSwitchClick(language) {
      this.$i18n.locale = language
    },
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.forgot-button {
  cursor: pointer;
  color: #607d8b;
}

.fair-title {
  color: #607d8b;
}

.login-card {
  border: 2px solid #e8e8e8 !important;
}

.login-overlay {
  min-height: 720px;
  /* height: 100vh; */
  /* padding-top: 90px; */
  color: #4b4b4b;
  background-color: #ffffff;
}

.login-inner {
  text-align: center;
}

.login-inner img {
  margin-bottom: 78px;
}
</style>
